import React, { useState, useEffect } from "react";
import AdminDashboard from "./admindashboard";
import { Button, Form, Table, Container, Row, Col, Card, Modal } from "react-bootstrap";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { FaTrash, FaEye, FaEyeSlash, FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router";


function Smtpconfigure() {
  const userid = JSON.parse(localStorage.getItem("data")).userid;
  const [smtpConfig, setSmtpConfig] = useState({
    host: "",
    port: "",
    username: "",
    password: "",
    adminlink: "",
  });
  const [configs, setConfigs] = useState([]);
  const [accounts, setAccounts] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfigPasswords, setShowConfigPasswords] = useState({}); // For showing passwords in the table
  const [fromAddress, setFromAddress] = useState(""); // State for from address
  const [loading, setLoading] = useState(false);
  const [ccRecipients, setCcRecipients] = useState(
    { 
      adminId: "", 
      ccRecipient: "" 
    },
  );
  const [selectedRecipient, setSelectedRecipient] = useState(null);
  const [ccRecipient, setCcRecipient] = useState({id:"", ccRecipient: "" });


    const [isRecipientUpdateModal, setIsRecipientUpdateModal] = useState(false);
  

  const [existingCcRecipients, setExistingCcRecipients] = useState([]);
  const navigate = useNavigate();


  useEffect(() => {
    fetchConfigs();
  }, []);

  const fetchConfigs = async () => {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("data")).token;

      const response = await axios.get(`/api/smtpconfiguration/adminlink=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setConfigs(response.data);

      const accRes = await axios.get(`/api/accounts/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAccounts(accRes.data);
      setFromAddress(accRes.data.fromaddress);

      const ccRes = await axios.get(`/api/cc-recipients/adminId=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setExistingCcRecipients(ccRes.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Error fetching configurations");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSmtpConfig((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;

      const smtpConfigWithFromAddress = {
        ...smtpConfig,
        fromaddress: fromAddress, 
      };

      await axios.post("/api/smtpconfiguration/create", smtpConfigWithFromAddress, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("SMTP configuration created successfully!");
      fetchConfigs();

      setSmtpConfig({
        host: "",
        port: "",
        username: "",
        password: "",
        adminlink: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error creating SMTP configuration");
    }
  };

  const handleDelete = async (config) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this configuration?");
    if (confirmDelete) {
      try {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("data")).token;

        await axios.delete("/api/smtpconfiguration", {
          headers: { Authorization: `Bearer ${token}` },
          data: config,
        });

        toast.success("SMTP configuration deleted successfully!");
        
        fetchConfigs();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error deleting SMTP configuration");
      }
    }
  };

  const handleDeleteCcRecipient = async (recipientId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this cc recipient?");
    if (confirmDelete) {
      try {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("data")).token;

        await axios.delete("/api/cc-recipients", {
          headers: { Authorization: `Bearer ${token}` },
          data: {
            id: `${recipientId}`,
          }
        });

        toast.success("Cc Recipient deleted successfully!");
        
        fetchConfigs();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleError(error);
      }
    }
  };


  // Function to handle saving From Address
  const handleSaveFromAddress = async () => {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("data")).token;

      // Make the API call to update the from address
      await axios.post("/api/accounts/update/fromaddress", { fromAddress }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("From Address updated successfully!");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error updating from address", error);
      toast.error("Error updating From Address");
    }
  };

    const handleUpdateRecipient = async (recipient) => {
    setSelectedRecipient(recipient);
    setCcRecipient({id:recipient?.id, ccRecipient:recipient?.ccRecipient})
    setIsRecipientUpdateModal(true);
  };
  

  const handleInputChange = (e) => {
    const inputValue = e.target.value.trim(); 
  
    if (inputValue === "") return; 
  
    // Set a single object, not an array
    setCcRecipients({ adminId: userid, ccRecipient: inputValue });
  };

  const handleChangeCc = (e) => {
    const { name, value } = e.target;
    setCcRecipient((prev) => ({ ...prev, [name]: value }));
  };

  
  const handleSaveCcRecipients = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!ccRecipients.ccRecipient || !emailPattern.test(ccRecipients.ccRecipient)) {
      toast.error("Please enter a valid email address");
      return; // Stop function execution if invalid
    }
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("data")).token;
  
      // Send a single object, not an array
      await axios.post("/api/cc-recipients/create", ccRecipients , {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      toast.success("CC Recipient added successfully!");
      setLoading(false);
      fetchConfigs();
      setCcRecipients({ccRecipient:""});
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handleUpdateSelectedRecipient = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!ccRecipient.ccRecipient || !emailPattern.test(ccRecipient.ccRecipient)) {
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("data")).token;
const updatedCcRecipient = {
  id: selectedRecipient?.id,
  ccRecipient: ccRecipient.ccRecipient, // Ensure email is included
};

await axios.post("/api/cc-recipients/update", updatedCcRecipient, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("CC Recipient updated successfully!");
      setLoading(false);
      fetchConfigs();
      setIsRecipientUpdateModal(false);
    } catch (error) {
      setLoading(false);
      toast.error("Failed to update recipient");
      console.error(error);
    }
  };
  
  function handleError(error) {
      if (error.response) {
        if (error.response.status === 401) {
          navigate(`/signin`);
          toast.error("Your session has expired. Please login.");
        } else if (error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("An error occurred.");
        }
      } else {
        toast.error("An error occurred.");
      }
    }
  

  const toggleConfigPasswordVisibility = (index) => {
    setShowConfigPasswords((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div>
      <br /><br /><br /><br />
      <AdminDashboard />
      {loading && <div className="loading"></div>}
      <Container className="mt-4">
      <Row>
  <Col md={{ span: 10, offset: 2 }}>
    <Row>
      {/* Left Column - SMTP Configuration */}
      <Col md={6}>
        <Card>
          <Card.Body>
            <Card.Title className="text-center mb-4">SMTP Configuration</Card.Title>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="host">
                <Form.Label>Host</Form.Label>
                <Form.Control
                  type="text"
                  name="host"
                  value={smtpConfig.host}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="port">
                <Form.Label>Port</Form.Label>
                <Form.Control
                  type="number"
                  name="port"
                  value={smtpConfig.port}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="username">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  name="username"
                  value={smtpConfig.username}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="password">
                <Form.Label>Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={smtpConfig.password}
                    onChange={handleChange}
                    required
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="position-absolute end-0 top-0 mt-2 me-3"
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? (
                      <FaEyeSlash className="icon-size" />
                    ) : (
                      <FaEye className="icon-size" />
                    )}
                  </span>
                </div>
              </Form.Group>
              <div className="text-end">
              <Button variant="primary" type="submit" className="mt-5">
                Create Configuration
              </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Col>

      {/* Right Column - From Address & CC Recipients */}
      <Col md={4}>
        <Card>
          <Card.Body>
            <Card.Title className="text-center mb-3">From Address</Card.Title>
            <Form.Group controlId="fromAddress">
              <Form.Label>From Address</Form.Label>
              <Form.Control
                type="text"
                value={fromAddress}
                onChange={(e) => setFromAddress(e.target.value)}
                placeholder="Enter From Address"
                required
              />
            </Form.Group>
            <div className="text-end">
            <Button variant="primary" className="mt-3" onClick={handleSaveFromAddress}>
              Save
            </Button>
            </div>
          </Card.Body>
        </Card>
        <Card className="mt-3">
        <Card.Body>
          <Card.Title className="text-center mb-3">CC Recipients</Card.Title>
          <Form.Group controlId="ccRecipients">
            <Form.Label>CC Recipients</Form.Label>
            <Form.Control
              type="text"
              value={ccRecipients.ccRecipient}
              onChange={handleInputChange}
              placeholder="Enter CC Recipient"
              required
            />
          </Form.Group>
          <div className="text-end">
            <Button variant="primary" className="mt-3" onClick={handleSaveCcRecipients}>
              Save
            </Button>
          </div>
        </Card.Body>
      </Card>
      </Col>
    </Row>




            <br />
            <Card>
              <Card.Body>
                <Card.Title className="text-center mb-4">Existing Configurations</Card.Title>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Host</th>
                      <th>Port</th>
                      <th>Username</th>
                      <th>Password</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {configs.length===0 ? (
                       <tr>
                       <td colSpan="10" className="text-center">
                         No Data Available
                       </td>
                     </tr>
                    ):(
                  configs.map((config, index) => (
                      <tr key={index}>
                        <td>{config.host}</td>
                        <td>{config.port}</td>
                        <td>{config.username}</td>
                        <td>
                          <div className="position-relative">
                            <span>
                              {showConfigPasswords[index] ? config.password : "••••••••"}
                            </span>
                            <span
                              onClick={() => toggleConfigPasswordVisibility(index)}
                              className="ms-2"
                              style={{ cursor: "pointer" }}
                            >
                              {showConfigPasswords[index] ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </td>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() => handleDelete(config)}
                          >
                            <FaTrash />
                          </Button>
                        </td>
                      </tr>
                    )))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>

            <br />
            <Card>
              <Card.Body>
                <Card.Title className="text-center mb-4">CC Recipients</Card.Title>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Recipient</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {existingCcRecipients.length===0 ? (
                       <tr>
                       <td colSpan="10" className="text-center">
                         No Data Available
                       </td>
                     </tr>
                    ):(
                  existingCcRecipients.map((ccr, index) => (
                      <tr key={index}>
                        <td>{index+1}</td>
                        <td>{ccr.ccRecipient}</td>
                      
                       
                        <td>
  <Button variant="warning" className="me-2" style={{ fontSize: "14px" }} onClick={() => handleUpdateRecipient(ccr)}>
    <FaEdit />
  </Button>
  
  <Button variant="danger" style={{ fontSize: "14px" }} onClick={() => handleDeleteCcRecipient(ccr.id)}>
    <FaTrash  />
  </Button>
</td>

                      </tr>
                    )))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            </Col>
            </Row>
 
      </Container>

      <Modal show={isRecipientUpdateModal} onHide={() => setIsRecipientUpdateModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Recipient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form.Group className="mb-3">
            <Form.Label>Cc Recipient</Form.Label>

          <Form.Control 
            type="email" 
            name="ccRecipient" 
            value={ccRecipient.ccRecipient || ""} 
            onChange={handleChangeCc} 
          />
        </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" 
          onClick={handleUpdateSelectedRecipient}
          >
            Update
          </Button>
          <Button variant="secondary" onClick={() => setIsRecipientUpdateModal(false)} className="ms-2">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Smtpconfigure;
